'use client';
// import React, { useState } from 'react';
import styles from './styles.module.scss';
// interface CarouselProps {
//   children: React.ReactNode;
//   maxWidth?: number;
// }
// const Slider: React.FC<CarouselProps> = ({ children, maxWidth }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const itemCount = React.Children.count(children);
//   const itemWidth = maxWidth || 100; // Change this value to adjust the width of each carousel item
//   const nextSlide = () => {
//     setCurrentIndex((currentIndex + 1) % itemCount);
//   };
//   const prevSlide = () => {
//     setCurrentIndex((currentIndex - 1 + itemCount) % itemCount);
//   };
//   const carouselStyle: React.CSSProperties = {
//     transform: `translateX(-${currentIndex * itemWidth}px)`,
//   };
//   return (
//     <div className={styles.carousel_container}>
//       <div className={styles.carousel}>
//         <div className={styles.carousel_track} style={carouselStyle}>
//           {React.Children.map(children, (child, index) => (
//             // <div className={styles.carousel_item} style={{ width: `${maxWidth}px` }}>
//             //   {child}
//             // </div>
//             <div>{child}</div>
//           ))}
//         </div>
//       </div>
//       <button onClick={prevSlide}>Previous</button>
//       <button onClick={nextSlide}>Next</button>
//     </div>
//   );
// };
// export default Slider;
// import React, { useState } from 'react';
// interface CircularCarouselProps {
//   children: React.ReactNode;
//   transitionDuration?: number; // Optional: Transition duration in milliseconds
//   maxWidth?: number;
// }
// const CircularCarousel: React.FC<CircularCarouselProps> = ({
//   children,
//   transitionDuration = 500,
//   maxWidth,
// }) => {
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const itemCount = React.Children.count(children);
//   const itemWidth = maxWidth || 100; // Change this value to adjust the width of each carousel item
//   const nextSlide = () => {
//     setCurrentIndex((currentIndex + 1) % itemCount);
//   };
//   const prevSlide = () => {
//     setCurrentIndex((currentIndex - 1 + itemCount) % itemCount);
//   };
//   const carouselStyle: React.CSSProperties = {
//     transform: `translateX(-${currentIndex * itemWidth}px)`,
//     transition: `transform ${transitionDuration}ms ease`,
//   };
//   return (
//     <div className={styles.circular_carousel_container}>
//       <div className={styles.circular_carousel} style={carouselStyle}>
//         {React.Children.map(children, (child, index) => (
//           <div style={{ width: `${itemWidth}px` }}>{child}</div>
//         ))}
//       </div>
//       <button onClick={prevSlide}>Previous</button>
//       <button onClick={nextSlide}>Next</button>
//     </div>
//   );
// };
// export default CircularCarousel;
import React, { useEffect, useRef, useState } from 'react';

interface SliderProps {
  children: React.ReactNode;
  slidesToShow?: number;
  autoplay?: boolean;
  autoplaySpeed?: number;
}

const Slider: React.FC<SliderProps> = ({
  children,
  slidesToShow = 1,
  autoplay = true,
  autoplaySpeed = 3000,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slideWidth = 100 / slidesToShow;
  const totalSlides = React.Children.count(children);
  const sliderRef = useRef<HTMLDivElement | null>(null);
  let autoplayTimer: NodeJS.Timeout | null = null;

  const nextSlide = () => {
    setCurrentIndex((currentIndex + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentIndex((currentIndex - 1 + totalSlides) % totalSlides);
  };

  useEffect(() => {
    if (autoplay) {
      autoplayTimer = setInterval(nextSlide, autoplaySpeed);
    }
    return () => {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
      }
    };
  }, [currentIndex, autoplay, autoplaySpeed]);

  const sliderStyle: React.CSSProperties = {
    width: `${totalSlides * 100}%`,
    transform: `translateX(-${(currentIndex * slideWidth) / slidesToShow}%)`,
  };

  return (
    <div className={styles.slider_container}>
      <div className={styles.slider} ref={sliderRef} style={sliderStyle}>
        {React.Children.map(children, (child, index) => (
          <div className={styles.slide} style={{ width: `${slideWidth}%` }}>
            {child}
          </div>
        ))}
      </div>
      <div className={styles.slider_controls}>
        <button onClick={prevSlide}>Previous</button>
        <button onClick={nextSlide}>Next</button>
      </div>
    </div>
  );
};

export default Slider;
